import React, { FC } from 'react';
import { useIconColor } from '../../../hooks/useIconColor';

interface IconPromoProps {
  className?: string;
  color?: string;
}

const IconPromo: FC<IconPromoProps> = (props: IconPromoProps) => {
  const { className, color } = props;

  const { iconColor } = useIconColor();
  const fillColor = color || iconColor;

  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.38 5.54518L16.8245 4.73584C16.4272 4.15698 15.5728 4.15698 15.1755 4.73584L14.6201 5.54518C13.5013 7.17536 11.5269 7.99316 9.5831 7.63155L8.61805 7.45203C7.92782 7.32363 7.32363 7.92783 7.45203 8.61805L7.63155 9.5831C7.99316 11.5269 7.17536 13.5013 5.54518 14.6201L4.73584 15.1755C4.15698 15.5728 4.15698 16.4272 4.73584 16.8245L5.54518 17.38C7.17536 18.4988 7.99316 20.4731 7.63155 22.4169L7.45203 23.382C7.32363 24.0722 7.92783 24.6764 8.61805 24.548L9.5831 24.3685C11.5269 24.0069 13.5013 24.8247 14.6201 26.4549L15.1755 27.2642C15.5728 27.843 16.4272 27.843 16.8245 27.2642L17.38 26.4549C18.4988 24.8247 20.4731 24.0069 22.4169 24.3685L23.382 24.548C24.0722 24.6764 24.6764 24.0722 24.548 23.382L24.3685 22.4169C24.0069 20.4731 24.8247 18.4988 26.4549 17.38L27.2642 16.8245C27.843 16.4272 27.843 15.5728 27.2642 15.1755L26.4549 14.6201C24.8247 13.5013 24.0069 11.5269 24.3685 9.5831L24.548 8.61805C24.6764 7.92782 24.0722 7.32363 23.382 7.45203L22.4169 7.63155C20.4731 7.99316 18.4988 7.17536 17.38 5.54518ZM18.4735 3.60412C17.2817 1.86756 14.7183 1.86755 13.5265 3.60412L12.9711 4.41346C12.2998 5.39157 11.1152 5.88225 9.94888 5.66529L8.98383 5.48576C6.91315 5.10056 5.10056 6.91315 5.48576 8.98383L5.66529 9.94888C5.88225 11.1152 5.39157 12.2998 4.41346 12.9711L3.60412 13.5265C1.86756 14.7183 1.86755 17.2817 3.60412 18.4735L4.41346 19.029C5.39157 19.7003 5.88225 20.8849 5.66529 22.0511L5.48576 23.0162C5.10056 25.0869 6.91315 26.8995 8.98383 26.5143L9.94888 26.3347C11.1152 26.1178 12.2998 26.6085 12.9711 27.5866L13.5265 28.3959C14.7183 30.1325 17.2817 30.1325 18.4735 28.3959L19.029 27.5866C19.7003 26.6085 20.8849 26.1178 22.0511 26.3347L23.0162 26.5143C25.0869 26.8995 26.8995 25.0869 26.5143 23.0162L26.3347 22.0511C26.1178 20.8849 26.6085 19.7003 27.5866 19.029L28.3959 18.4735C30.1325 17.2817 30.1325 14.7183 28.3959 13.5265L27.5866 12.9711C26.6085 12.2998 26.1178 11.1152 26.3347 9.94888L26.5143 8.98383C26.8995 6.91315 25.0869 5.10056 23.0162 5.48576L22.0511 5.66529C20.8849 5.88225 19.7003 5.39157 19.029 4.41346L18.4735 3.60412Z"
        fill={fillColor}
      />
      <rect
        x="11"
        y="19.4853"
        width="12"
        height="2"
        transform="rotate(-45 11 19.4853)"
        fill={fillColor}
      />
      <circle cx="13" cy="13" r="2" fill="#454545" />
      <circle cx="19" cy="19" r="2" fill="#454545" />
    </svg>
  );
};

export default IconPromo;
